export const displayMode = {
    days: 1,
    months: 2,
    years: 3
}
export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]
export const weekdays = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
export const operator ={
    increase : 1,
    decrease : -1
}